var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-carousel',{attrs:{"interval":5000,"arrow":"never","height":_setup.bannerHeight + 'px'}},_vm._l((_setup.bannerList),function(item){return _c('el-carousel-item',{key:item},[_c('router-link',{attrs:{"to":"/prolist"}},[_c('img',{staticClass:"banner-img",attrs:{"src":item,"alt":""}})])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }